import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthRequest } from '../../../models/auth-request.model';
import { environment } from '../../../../environments/environment';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { Company } from 'src/app/models/company.model';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { HasSubscription } from 'src/app/interfaces/services/subscription.interface';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { PendingSubscriptionsService } from 'src/app/services/pending-subscriptions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PendingSubscription } from 'src/app/interfaces/subscription.interface';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Helper from 'src/app/Util/helper';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.sass']
})

export class SignInComponent implements OnDestroy, OnInit, HasSubscription {

  public error: string;
  authCode: string | undefined;

  faUserPlus = faUserPlus;
  userHasSubscription = false;
  fetchedUserDetails = false;
  stateId = null;
  cloudUser = {};

  company: Company;

  @ViewChild('PendingSubscriptions') pendingSubscriptionsModal: ElementRef;

  pendingSubscriptions: PendingSubscription[] = [];
  selectedPendingSubscription: string;
  environment = environment;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private readonly notifcationSvc: CloudNotificationService,
    private route: ActivatedRoute,
    private authSvc: CloudAuthenticationService,
    private router: Router,
    private subscriptionSvc: CloudSubscriptionService,
    private pendingSubscriptionService: PendingSubscriptionsService,
    private localStorageSvc:LocalStorageService,
    private cloudSubscriptionService:CloudSubscriptionService,
    private modalService: NgbModal) { }

  ngOnInit(): void {

    this.getAuthCodeFromState();

    if (!this.authCode) {
      this.router.navigate([environment.routes.login])
    }

    this.resolveAuthToken();
  }

  private getAuthCodeFromState(): void {

    if (history.state) {
      this.authCode = history.state.code;
    } else {
      this.authCode = undefined;
    }
  }

  private resolveAuthToken(): void {

    this.authSvc.resolveAuthToken({ code: this.authCode }).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: async (isAuthenticated) => {
        let storedUrl = this.localStorageSvc.getItemSessionStorage(StorageKeys.email_path)
        if(storedUrl != null){
          const [path, queryString] = storedUrl.split('?');
          const queryParams: { [key: string]: string } = {};
          if (queryString) {
            const searchParams = new URLSearchParams(queryString);
            searchParams.forEach((value, key) => {
              queryParams[key] = value;
            });
            this.localStorageSvc.removeItemSessionStorage(StorageKeys.email_path)
            if('subscriptionId' in queryParams){
              this.localStorageSvc.setItemSessionStorage(StorageKeys.SubscriptionId,queryParams['subscriptionId'],)
              this.router.navigate([path], { queryParams });
            }
            else{
              this.router.navigate([environment.routes.subscription]);
            }
          }
        }
        else{
          this.router.navigate([environment.routes.subscription]);
        }
      },

      error: (error: HttpErrorResponse) => {
        this.error = Helper.resolveErrorMessage(error);
        this.notifcationSvc.createToastNotification('auth', this.error, CloudNotificationStyle.danger);
        if (this.error.includes('OTP')) this.router.navigate([environment.routes.login], { queryParams: { code: this.authCode, error: 'unverified' } });
        else this.router.navigate([environment.routes.login], { queryParams: { code: this.authCode } });
      }

    });
  }

  ngOnDestroy(): void {
    this.closeModal();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  hasSubscription() {
    return this.subscriptionSvc.hasSubscription();
  }
}
